export enum RETURN_REASON {
    NONE = 'NONE',
    REMORSE = 'REMORSE',
    DEFECTIVE = 'DEFECTIVE',
    QUALITY_BELOW_EXPECTED = 'QUALITY_BELOW_EXPECTED',
    DESCRIPTION_MISMATCH = 'DESCRIPTION_MISMATCH',
    WRONG_ITEM = 'WRONG_ITEM',
    GIFT_RETURN = 'GIFT_RETURN',
    OTHER = 'OTHER',
}
